var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3"},[_c('StackedBarChart',{attrs:{"chart-data":_vm.chartData,"view-box":[800, 200]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }